import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function AboutSection() {
  const benefits = ['Upfront, transparent pricing', 'Always on time & professional', 'Fully licensed & insured', 'Locally owned family business'];
  return <section className="py-20 bg-white overflow-hidden" data-id="element-35">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-37">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full lg:w-1/2" data-id="element-38">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-39">
              <div className="brand-overlay" data-id="element-40">
                <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80" alt="Dominic Moceri - Licensed Builder" className="w-full h-[500px] object-cover" data-id="element-41" />
              </div>
              {/* Badge */}
              <div className="absolute bottom-6 right-6 bg-white p-4 rounded-xl shadow-lg border border-gray-100 max-w-[200px]" data-id="element-42">
                <div className="font-heading font-bold text-3xl text-brand-blue mb-1" data-id="element-43">
                  15+
                </div>
                <div className="font-body text-sm text-brand-gray-dark font-semibold leading-tight" data-id="element-44">
                  Years of Michigan Craftsmanship
                </div>
              </div>
            </div>
          </motion.div>

          {/* Text Column */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full lg:w-1/2" data-id="element-45">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-brand-gray-dark mb-4" data-id="element-46">
              Meet Dominic Moceri
            </h2>
            <div className="w-20 h-1 bg-brand-blue mb-6 rounded-full" data-id="element-47"></div>

            <p className="font-body text-brand-gray text-lg mb-6 leading-relaxed" data-id="element-48">
              Founded in 2009, Moceri Residential Services was built on a simple
              premise: treat every home like it's our own. As a licensed builder
              local to Harrison Township, Dominic Moceri has spent over a decade
              serving neighbors across Macomb and St. Clair counties.
            </p>
            <p className="font-body text-brand-gray text-lg mb-8 leading-relaxed" data-id="element-49">
              We don't rely on high-pressure sales tactics or generic corporate
              scripts. We provide honest assessments, premium materials, and
              meticulous installation that stands up to Michigan's toughest
              weather.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10" data-id="element-50">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3" data-id="element-51">
                  <CheckCircle2 className="text-brand-blue shrink-0 mt-0.5" size={20} data-id="element-52" />
                  <span className="font-body text-brand-gray-dark font-medium" data-id="element-53">
                    {benefit}
                  </span>
                </div>)}
            </div>

            <Link to="/about" className="inline-flex items-center gap-2 bg-brand-gray-dark hover:bg-black text-white font-body font-bold py-3.5 px-8 rounded-lg transition-colors" data-id="element-54">
              Learn More About Us
              <ArrowRight size={18} data-id="element-55" />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>;
}